import type { ReactNode } from 'react';

export const symbol_nest_cam_indoor: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M409-529q-29-29-29-71t29-71q29-29 71-29t71 29q29 29 29 71t-29 71q-29 29-71 29t-71-29ZM280-80q0-25 17.5-42.5T340-140h110q0-69-33-128.5T326-366q-60-39-93-101t-33-133q0-117 81.5-198.5T480-880q117 0 198.5 81.5T760-600q0 72-34 134t-94 101q-57 37-89.5 96.5T510-140h110q25 0 42.5 17.5T680-80H280Zm356-364q64-64 64-156t-64-156q-64-64-156-64t-156 64q-64 64-64 156t64 156q64 64 156 64t156-64Z"
		/>
	</svg>
);
